import axios from "axios";
import Cookies from "js-cookie";
import { debouncedErrorMessage } from "utils/messageUtil";

export default function ajax(url = "", data = {}, type = "GET", headers = {}) {
  //collecting error within the function instead of rejecting the error
  return new Promise((resolve, reject) => {
    let promise = null;
    let newHeaders = {...headers};
    const token = Cookies.get("token") || "";
    if (token) {
      newHeaders.Authorization = `Bearer ${token}`;
    }
    const service = axios.create({
      baseURL:
        process.env.REACT_APP_DEVELOPMENT === "development"
          ? `${process.env.REACT_APP_REMOTE_ENDPOINT}`
          : "/",
      headers: newHeaders,
    });

    switch (type) {
      case "GET":
        promise = service.get(url, { params: data });
        break;
      case "POST":
        promise = service.post(url, data);
        break;
      case "PUT":
        promise = service.put(url, data);
        break;
      case "DELETE":
        promise = service.delete(url, { params: data });
        break;
      default:
        const content = "Request type is wrong!";
        debouncedErrorMessage(content);
    }

    promise
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        resolve(error);
        const content = error.message;
        debouncedErrorMessage(content);
      });
  });
}
